import React from 'react';
import { Row, Col } from 'antd';
// import { getTimeFromString } from '../../../../../../common/utils/format';

import {
  MidPointAddress,
  // MidPointTime
} from './fieldsConfig';
import moment from "moment";

const RouteMidPoint = ({ decorator, number, address, time }) => {
  return (
    <div>
      <Row type="flex" align="middle" className="formRow double-margin" gutter={16}>
        <Col span={6} className="formCol right">
          <span className="label">Промежуточный пункт {number}:</span>
        </Col>
        <Col span={12} className="formCol">
          <MidPointAddress
            decorator={decorator}
            classes="long"
            val={address}
            disabled
          />
          <span className="fieldInfo">{`Длительность плановой остановки в промежуточном пункте: ${moment.duration(time).asMinutes()} мин`}</span>
        </Col>
      </Row>
      {/*task 1*/}
      {/*<Row type="flex" align="middle" className="formRow" gutter={16}>*/}
      {/*  <Col span={6} />*/}
      {/*  <Col*/}
      {/*    span={12}*/}
      {/*    className="formCol right"*/}
      {/*    style={{ paddingRight: '32px' }}*/}
      {/*  >*/}
      {/*    <span className="info">*/}
      {/*      Длительность остановки*/}
      {/*      <br /> в промежуточном пункте {number}:*/}
      {/*    </span>*/}
      {/*    <MidPointTime*/}
      {/*      decorator={decorator}*/}
      {/*      classes="medium"*/}
      {/*      val={getTimeFromString(time)}*/}
      {/*      disabled*/}
      {/*    />*/}
      {/*  </Col>*/}
      {/*</Row>*/}
    </div>
  );
};

export default RouteMidPoint;
